// Numbers, days and cells as MizuIQ's answers write them - in the chat
// window's figures, charts and tables (ChatVisuals.jsx) and in an answer's
// exports (chatExport.js).

export const isNumber = (value) => value !== null && value !== undefined && value !== "" && Number.isFinite(Number(value));

export const dayOf = (iso) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso ?? ""));
  return match ? new Date(Date.UTC(+match[1], +match[2] - 1, +match[3])) : null;
};
export const formatDay = (date, options) => date.toLocaleDateString("en-US", { timeZone: "UTC", ...options });

// An x value as an axis says it ("Oct 5", "Oct 2026", "14:00") - or, long,
// as a tooltip does ("Mon, Oct 5, 2026", "Week of Oct 5, 2026").
export function formatX(x, kind, long = false) {
  if (kind === "date" || kind === "week" || kind === "month") {
    const date = dayOf(x);
    if (!date) return String(x ?? "");
    if (kind === "month") return formatDay(date, { month: "short", year: "numeric" });
    if (!long) return formatDay(date, { month: "short", day: "numeric" });
    if (kind === "week") return `Week of ${formatDay(date, { month: "short", day: "numeric", year: "numeric" })}`;
    return formatDay(date, { weekday: "short", month: "short", day: "numeric", year: "numeric" });
  }
  return String(x ?? "");
}

export const shorten = (text, length) => (text.length > length ? `${text.slice(0, length - 1)}…` : text);

// 1234567 -> "1.2M", 48210 -> "48K", 1520 -> "1.5K", 12.5 -> "12.5".
export function compact(value) {
  const n = Number(value);
  const size = Math.abs(n);
  if (size >= 1e9) return `${(n / 1e9).toFixed(1)}B`;
  if (size >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (size >= 1e4) return `${Math.round(n / 1e3)}K`;
  if (size >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return `${Math.round(n * 10) / 10}`;
}

export const axisValue = (value, unit) => (unit === "%" ? `${Math.round(value)}%` : compact(value));

// A value in full, with its unit: "1,234,567 gal", "92%", "14 meters".
export function formatValue(value, unit) {
  if (!isNumber(value)) return "–";
  const n = Number(value);
  if (unit === "%") return `${Math.round(n * 10) / 10}%`;
  const text = Math.abs(n) >= 100 ? Math.round(n).toLocaleString() : (Math.round(n * 100) / 100).toLocaleString();
  return unit ? `${text} ${unit}` : text;
}

export function formatCell(value, format) {
  if (value === null || value === undefined || value === "") return "–";
  switch (format) {
    case "gallons":
      return isNumber(value) ? Math.round(Number(value)).toLocaleString() : String(value);
    case "money":
      return isNumber(value) ? Number(value).toLocaleString("en-US", { style: "currency", currency: "USD" }) : String(value);
    case "percent":
      return isNumber(value) ? `${Math.round(Number(value) * 10) / 10}%` : String(value);
    case "rate":
    case "number":
      return isNumber(value) ? (Math.round(Number(value) * 10) / 10).toLocaleString() : String(value);
    // A Super Mode query's measures, as exact as they are useful:
    // 12,345.68 - 0.0123.
    case "decimal":
      return isNumber(value)
        ? Number(value).toLocaleString("en-US", { maximumFractionDigits: Math.abs(Number(value)) >= 1 ? 2 : 4 })
        : String(value);
    case "date": {
      const date = dayOf(value);
      return date ? formatDay(date, { month: "short", day: "numeric", year: "numeric" }) : String(value);
    }
    default:
      return String(value);
  }
}
